
import React, { useEffect, useState } from 'react'
import { Form, FormInput } from '../../../../tabs/PaymentsTab/onestep-library/BaseUI'
import moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { sendStaffAppMetaData } from '../../../../staffApp/eventTriggers';
import { postDischargeDestinationOptions } from '../../../../utils';

export default function OverviewPage(props) {
  const dispatch = useDispatch();
  const { resident, ui, groups, organization, users, config } = useSelector(state=>state)
  const { occupancy, is_submitting, errors } = ui.dischargeModal;
  const group = groups.find(group => group.id == occupancy.group_id)  || {}

  const hasTVSurvey = !!useSelector(state=> state.outcomes.enabled_surveys).find(survey=> survey.slug == 'tv-exit-survey')
  const hasAlumniChat = users.length > 0 && !!group.managed_group_chats && !!group.managed_group_chats.find(chat => chat.kind == 'alumni')

  const { reason_for_discharge_options } = useSelector(state=>state.org_dependant_data)
  const { onClose } = props

  const [ recurringCharges, setRecurringCharges ] = useState([])
  const [ should_pause_recurring_charges, set_should_pause_recurring_charges ] = useState()
  const [ should_schedule_survey, set_should_schedule_survey ] = useState()
  const [ request_review, setRequestReview ] = useState();
  const [ should_add_to_alumni_group, set_should_add_to_alumni_group ] = useState()
  const [ should_remove_from_all_opted_in_conversations, set_should_remove_from_all_opted_in_conversations ] = useState()

  const tabDefaultMetaData =  useSelector(state=>state.config.tab_default_meta_data.find(tab=> tab.detail == 'current_occupancies'))

  const [ moved_out_at, set_moved_out_at ] = useState(moment());
  const [ reason_for_discharge, set_reason_for_discharge ] = useState(null);
  const [ is_successful_discharge, set_is_successful_discharge ] = useState(null);
  const [ post_discharge_destination, set_post_discharge_destination ] = useState(null);

  function onValidateRequiredFields(){
    return(
      !!moved_out_at &&
      ( recurringCharges.length == 0 || !!should_pause_recurring_charges ) &&
      ( !hasTVSurvey || !!should_schedule_survey ) &&
      ( !!should_remove_from_all_opted_in_conversations ) &&
      ( !hasAlumniChat || !!should_add_to_alumni_group ) &&
      !!is_successful_discharge && !!post_discharge_destination
    )
  }

  function onSubmit(){
    dispatch({type: 'BEGIN_DISCHARGE_RESIDENT_FORM' })
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/discharge.json`,
      method: 'POST',
      data: {
        discharge: {
          occupancy_id: occupancy.id,
          should_schedule_survey: should_schedule_survey ? should_schedule_survey.value : null,
          should_pause_recurring_charges: should_pause_recurring_charges ? should_pause_recurring_charges.value : null,
          should_remove_from_all_opted_in_conversations: should_remove_from_all_opted_in_conversations ? should_remove_from_all_opted_in_conversations.value : null,
          should_add_to_alumni_group_chat: should_add_to_alumni_group ? should_add_to_alumni_group.value : null,
          request_review: request_review ? request_review.value : null
        },
        occupancy: {
          reason_for_discharge,
          is_successful_discharge: is_successful_discharge ? is_successful_discharge.value : null,
          post_discharge_destination: post_discharge_destination,
          moved_out_at: moved_out_at.format('YYYY-MM-DD')
        }
      },
      success: (data) => {
        const occupancies = data.occupancies
        dispatch({type: 'SUCCESS_DISCHARGE_RESIDENT_FORM'})
        dispatch({type: 'UPDATE_OCCUPANCIES', payload: { occupancies }})
        sendStaffAppMetaData(tabDefaultMetaData)
      },
      error: xhr => {
        const errors  = $.parseJSON(xhr.responseText).errors
        dispatch({type: 'FAILED_DISCHARGE_RESIDENT_FORM', payload: errors })
      }
    })
  }


  useEffect(()=>{
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/recurring_charges/has_recurring_charges.json`,
      success: (response) => {
          setRecurringCharges(response)
      }
    })
  },[])

  const showRequestReview = (organization['sober_home?'] || organization['recovery_coaching?']) &&
      organization.services_names.includes('online_presence');

  return (
    <Form
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleClose={onClose}
      showCancel={!config.isStaffApp}
      submitButtonLabel="Discharge"
      isSubmitting={is_submitting}
      errors={errors}
      validationMessage="">
      {
        occupancy.group_id &&
        <div className="mb-2">
          <b>{resident.first_name} {resident.last_name}</b> will be discharged from <b>{group.name}</b> on
        </div>
      }
      <FormInput
        type="date"
        value={moved_out_at}
        handleChange={ value => set_moved_out_at(value) }/>
      <FormInput
        label="Is a successful discharge?"
        type="select"
        options={[{label:'Yes', value:true}, {label: 'No', value: false}]}
        value={is_successful_discharge}
        handleChange={e=>set_is_successful_discharge(e)}
      />
      <FormInput
        label="Reason For Discharge"
        type="select"
        isCreatable
        options={reasonForDischargeOptions(reason_for_discharge_options)}
        handleChange={e => set_reason_for_discharge(e.value) }/>
      <FormInput
        label="Post Discharge Destination"
        type="select"
        options={postDischargeDestinationOptions}
        handleChange={e => set_post_discharge_destination(e.value) }
        />
      {
        recurringCharges.length > 0 &&
        <FormInput
          label={`${resident.first_name} has active recurring charges. Would you like to pause them on the discharged date?`}
          type="select"
          desc="NOTE: If discharge date is today or in the past, recurring charges will be paused immediately."
          options={[{label:'Yes', value:true}, {label: 'No', value: false}]}
          value={should_pause_recurring_charges}
          handleChange={e=>set_should_pause_recurring_charges(e)}
        />
      }
      {
        hasTVSurvey &&
        <FormInput
          label={`Would you like to schedule the Exit Survey for 30, 60, and 90 days after discharge?`}
          type="select"
          desc="NOTE: If discharge date is today or in the past, the first survey will be scheduled 30 days from today."
          options={[{label:'Yes', value:true}, {label: 'No', value: false}]}
          value={should_schedule_survey}
          handleChange={e=>set_should_schedule_survey(e)}
        />
      }
      {
        <FormInput
            label={`Would you like to remove ${resident.first_name} from the all conversations upon discharge?`}
            type="select"
            desc={`NOTE: If discharge date is today or in the past, will be ${resident.first_name} removed from all conversations immediately.`}
            options={[{label: 'Yes', value: true}, {label: 'No', value: false}]}
            value={should_remove_from_all_opted_in_conversations}
            handleChange={e => set_should_remove_from_all_opted_in_conversations(e)}
        />
      }
      {
        showRequestReview &&
        <FormInput
          label={`Request review from Client`}
          type="select"
          options={[{label:'Yes', value:true}, {label: 'No', value: false}]}
          value={request_review}
          handleChange={e=>setRequestReview(e)}
        />
      }
      {
        hasAlumniChat &&
        <FormInput
          label={`Would you like to add ${resident.first_name} to the alumni group message for ${group.name} upon discharge?`}
          type="select"
          desc={`NOTE: If discharge date is today or in the past, will be ${resident.first_name} added to the alumni group message immediately.`}
          options={[{label:'Yes', value:true}, {label: 'No', value: false}]}
          value={should_add_to_alumni_group}
          handleChange={e=>set_should_add_to_alumni_group(e)}
        />
      }
    </Form>
  )
}

function reasonForDischargeOptions(reason_for_discharge_options){
  const options = reason_for_discharge_options
  var formattedOptions= []
  options.map(option=> formattedOptions.push({
    label: option,
    value: option
  }))
  return formattedOptions
}
